import { render, staticRenderFns } from "./SVGIcons.vue?vue&type=template&id=ba7e493e&scoped=true&"
import script from "./SVGIcons.vue?vue&type=script&lang=js&"
export * from "./SVGIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7e493e",
  null
  
)

export default component.exports